import React, { useEffect, useState } from 'react';
import "./AltScheduleTable.scss"
import { useSelector } from 'react-redux';
import { createMonthsColumns } from '../../../helpers/table';
import SpecialistColumn from '../SpecialistColumn/SpecialistColumn';
import AltScheduleColumn from '../AltScheduleColumn/AltScheduleColumn';

const AltScheduleTable = ({ specialists, salons, slots, currentSchedule, specialistsLeaves, ref }) => {
    const period = useSelector(state => state.schedule.period);

    const [columns, setColumns] = useState([]);

    useEffect(() => {
        setColumns(createMonthsColumns(period))
    }, [])

    useEffect(() => {
        setColumns(createMonthsColumns(period))
    }, [period])

    const selectSlotsAction = (id, isHover) => () => {
        const salonElements = document.querySelectorAll(`[data-salon-id="${id}"]`);
        
        if (isHover) {
            for (let i = 0; i < salonElements.length; i++) {
                salonElements[i].classList.add("hovered");
            }
        } else {
            for (let i = 0; i < salonElements.length; i++) {
                salonElements[i].classList.remove("hovered");
            }
        }
    };

    const rowHoverAction = (id, isHover) => () => {
        const rowElements = document.querySelectorAll(`[data-row-id="${id}"]`);

        if (isHover) {
            for (let i = 0; i < rowElements.length; i++) {
                rowElements[i].classList.add("selected");
            }
        } else {
            for (let i = 0; i < rowElements.length; i++) {
                rowElements[i].classList.remove("selected");
            }
        }
    };

    return (
        <div className="alt-schedule-table schedule-table" ref={ref}>
            <div className="alt-schedule-table__inner">
                <SpecialistColumn specialists={specialists} rowHoverAction={rowHoverAction} />
                {columns.map((column, index) => {

                    return (
                        <AltScheduleColumn
                            element={column}
                            specialists={specialists}
                            salons={salons}
                            slots={slots}
                            currentSchedule={currentSchedule}
                            key={column.date}
                            selectSlotsAction={selectSlotsAction}
                            specialistsLeaves={specialistsLeaves}
                        />
                    )
                })}
            </div>
        </div>
    );
};

export default AltScheduleTable;